// Firebase クライアント初期化(フロント)
import { initializeApp } from "firebase/app";
import { getAuth, type User } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);

export interface Claims {
  role?: "hq" | "staff";
  companyId?: string;
}

/**
 * Admin SDK でカスタムクレーム({role, companyId})を付与した直後は、
 * クライアント側で強制的にIDトークンを再取得しないと Firestore Rules / API の
 * 認可判定に反映されない(ブラウザがキャッシュ済みトークンを使い続けるため)。
 * ログイン直後・「権限が反映されない」問い合わせ時にはこの関数を呼ぶ運用とする。
 */
export async function refreshClaims(user: User): Promise<Claims> {
  const token = await user.getIdTokenResult(true); // true = 強制リフレッシュ
  return { role: token.claims.role as Claims["role"], companyId: token.claims.companyId as string | undefined };
}
